// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"card__msignaturepad___EyX9n","m-signature-pad--body":"card__m-signature-pad--body___3tmwJ","m-signature-pad--footer":"card__m-signature-pad--footer___11d_n","description":"card__description___8C-cf","button":"card__button___2kEaA","clear":"card__clear___3UISX","save":"card__save___27yS6","m-signature-pad":"card__m-signature-pad___1ut8g","github":"card__github___1kYAs"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/Unauthorized/card.scss
// module id = T3qJ
// module chunks = client